import { t } from 'i18next'

import { ClickCutoffAlertIcon } from '~/modules/retailMedia/components/ClickCutoffAlertIcon'
import { RoasMetricCell } from '~/modules/retailMedia/components/RoasMetricCell'

export const haloColumns: SchemaItems = {
  haloRevenue: {
    title: t('rm:metrics.haloRevenue'),
    sortKey: 'halo_revenue',
    sortInitialToggleDirection: 'DESC',
    render: ({ metrics }) => metrics?.haloRevenue || '-'
  },
  roasHalo: {
    title: t('rm:metrics.roasHalo'),
    helpText: t('rm:metrics.roasHalo.tooltip'),
    sortKey: 'roas_halo',
    sortInitialToggleDirection: 'DESC',
    render: ({ metrics }) => metrics?.roasHalo || '-'
  },
  haloOrders: {
    title: t('rm:metrics.haloOrders'),
    sortKey: 'halo_orders',
    sortInitialToggleDirection: 'DESC',
    render: ({ metrics }) => metrics?.haloOrders || '-'
  },
  haloItems: {
    title: t('rm:metrics.haloItems'),
    sortKey: 'halo_items',
    sortInitialToggleDirection: 'DESC',
    render: ({ metrics }) => metrics?.haloItems || '-'
  },
  roasOverall: {
    title: t('rm:metrics.roasOverall'),
    helpText: t('rm:metrics.roasOverall.tooltip'),
    sortKey: 'roas_overall',
    sortInitialToggleDirection: 'DESC',
    render: ({ metrics }) => (
      <RoasMetricCell
        metric="overall_roas"
        value={metrics?.roasOverall || '-'}
        raw={metrics?.raw}
      />
    )
  }
}

export function buildClickAttributionColumns(
  showClickAlert = false
): SchemaItems {
  const alertIcon = showClickAlert ? <ClickCutoffAlertIcon /> : undefined
  return {
    roasClick: {
      title: t('rm:metrics.roasClick'),
      headerSuffix: alertIcon,
      sortKey: 'roas_click',
      sortInitialToggleDirection: 'DESC',
      render: ({ metrics }) => metrics?.roasClick || '-'
    },
    conversionRateClick: {
      title: t('rm:metrics.conversionRateClick'),
      headerSuffix: alertIcon,
      sortKey: 'conversion_rate_click',
      sortInitialToggleDirection: 'DESC',
      render: ({ metrics }) => metrics?.conversionRateClick || '-'
    },
    conversionsClick: {
      title: t('rm:metrics.conversionsClick'),
      headerSuffix: alertIcon,
      sortKey: 'conversions_click',
      sortInitialToggleDirection: 'DESC',
      render: ({ metrics }) => metrics?.conversionsClick || '-'
    },
    salesClick: {
      title: t('rm:metrics.salesClick'),
      headerSuffix: alertIcon,
      sortKey: 'income_click',
      sortInitialToggleDirection: 'DESC',
      render: ({ metrics }) => metrics?.incomeClick || '-'
    },
    soldItemsClick: {
      title: t('rm:metrics.SoldItemsClick'),
      headerSuffix: alertIcon,
      sortKey: 'total_conversions_items_quantity_click',
      sortInitialToggleDirection: 'DESC',
      render: ({ metrics }) =>
        metrics?.totalConversionsItemsQuantityClick || '-'
    }
  }
}
